import { filter, map, Subject } from 'rxjs';
import {
  getCookie,
  getData,
  metricsLog,
  setData
} from './utils';
import { deDupeLastVal } from './completion';
import { PixelsVideoEvent } from '../../constants/Video';

export const completionTime = (sub: Subject<[string, any]>, pixelsUUIDKey: string, typeOfIntegration: string) => {
  const timeChange$ = sub.pipe(
    filter(([type]: [string, any]) => [PixelsVideoEvent.TIME, PixelsVideoEvent.FIRST_FRAME].includes(type as PixelsVideoEvent)),
    map(([eventType, { position }]) => eventType === PixelsVideoEvent.FIRST_FRAME ? 0 : Math.floor(position)),
    filter(deDupeLastVal()),
  );

  timeChange$.subscribe((seconds) => {
    const uuid = getCookie(pixelsUUIDKey);
    const storageKey = `${uuid}-${typeOfIntegration}`;
    const data = getData(storageKey);

    metricsLog(`Completion time updated to ${seconds}`);

    setData(storageKey, {
      ...data,
      time_watched: {
        value: seconds
      }
    });
  });
};